'use client';

export const SaleLoading = () => {
  return (
    <div className="mx-auto max-w-[640px] text-center py-12 text-[#6C7286]">
      <p className="text-lg">Загрузка...</p>
    </div>
  );
};
